import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import {LoadRegistrastionJournyData} from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function UpdateAsinManagementStatusService(token,data) {
    console.log(token)
    return axios.post(`${CURRENT_API_URL}/account/updateAsinManagementStatus`, data,{

        headers: {
            'Authorization': token,
        }
    }).then(res => {
            return res.data;        
    }).catch(error => {
        return false;
    });
}

export default UpdateAsinManagementStatusService;